export default __webpack_public_path__ + "static/media/Shiddat.01a0dfc9.png";